// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uXOJ","tabsBox":"styles_tabsBox__Nf21e","createButton":"styles_createButton__2wX4i"};